import * as React from 'react';
import { SidebarPrice } from '../../components/SidebarPrice';
import { useSelector } from 'react-redux';
import { selectPrice } from '../../selectors';
import { SidebarContactsContainer } from '../SidebarContactsContainer';
import { CallbackContainer } from '../CallbackContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

export const SidebarPriceContainer = () => {
  const { startPrice, endPrice } = useSelector(selectPrice);

  return (
    <SidebarPrice
      startPrice={startPrice}
      endPrice={endPrice}
      contactsButton={<SidebarContactsContainer />}
      callbackButton={<CallbackContainer placement={ECallbackWidgetPlacement.Sidebar} />}
    />
  );
};
